// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  graphql: 'https://wms-stg.farmaciadarrabida.pt/api/graphql',
  //graphql: 'https://27mktpw1-3000.uks1.devtunnels.ms/api/graphql',
  //graphql: 'https://27mktpw1-3000.uks1.devtunnels.ms/api/graphql',
  api: 'https://wms-stg.farmaciadarrabida.pt/api',
  base: 'https://localhost:8100/',
  KEY_LOCAL_STORAGE: 'wms_picking_farmacia_dev_access_token',
  KEY_LOCAL_STORAGE_COMPANY: 'wms_picking_farmacia_dev_company',
  KEY_LOCAL_STORAGE_ROLES: 'wms_picking_farmacia_dev_roles',

  KEY_WAREHOUSE_ID: 1,
  KEY_WAREHOUSE_NAME: 'Farmácia da Arrábida',

  //KEY_WAREHOUSE_ID: 2,
  //KEY_WAREHOUSE_NAME: 'Arcozelo',

  passphrase:
    'Obedient Cool Feel Nature Patience Separation Shoot Theater Mud Committee 5',
  aeskey: 'XKviu4Pqhn@NcRfUjXnr6slsXSet!!8vGiC$$j9yPdSgVk/Ypr6slsXSet8vGi'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
